"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _FloatingActionButton = require("./FloatingActionButton.style");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var FloatingActionButton = function FloatingActionButton(_ref) {
  var as = _ref.as,
    href = _ref.href,
    to = _ref.to,
    onClick = _ref.onClick,
    text = _ref.text,
    isHidden = _ref.isHidden;
  return /*#__PURE__*/_react.default.createElement(_FloatingActionButton.ButtonFixedPosition, null, /*#__PURE__*/_react.default.createElement(_FloatingActionButton.Button, {
    as: as,
    "data-key": "max-floating-action-button",
    href: href,
    isHidden: isHidden,
    onClick: onClick,
    to: to
  }, /*#__PURE__*/_react.default.createElement(_FloatingActionButton.Text, {
    "data-key": "max-floating-action-button__text"
  }, text)));
};
FloatingActionButton.defaultProps = {
  as: 'button',
  isHidden: false
};
var _default = FloatingActionButton;
exports.default = _default;